import { render, staticRenderFns } from "./branchTransferDetailsFormComponent.vue?vue&type=template&id=d5b57656"
import script from "./branchTransferDetailsFormComponent.vue?vue&type=script&lang=js"
export * from "./branchTransferDetailsFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports